import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import IndexFormHandler from '@Modules/cardManagementSystem/prepaid/containers/tableHandlers/card/anonymousCardProduction/index/IndexFormHandler';
import BatchRecordingFormHandler from '@Modules/cardManagementSystem/prepaid/containers/tableHandlers/card/anonymousCardProduction/batchRecording/BatchRecordingFormHandler';
import DestinationFormHandler from '@Modules/cardManagementSystem/prepaid/containers/tableHandlers/card/anonymousCardProduction/destination/DestinationFormHandler';

export default function AnonymousCardProduction() {
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Production de cartes anonymes
        </CC.Text>
        <IndexFormHandler />
      </CC.Box>
      <CC.Tabs>
        <div style={{overflow: 'auto'}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Enregistrement Batch</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Destination</CC.Tab>
          </CC.TabList>
        </div>

        <CC.TabPanels>
          <CC.TabPanel>
            <BatchRecordingFormHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <DestinationFormHandler />
          </CC.TabPanel>
        </CC.TabPanels>
    </CC.Tabs>
    </>
  );
}